import { useMemo } from 'react';
import {
  getTaskPointsText,
  getTaskThresholdText,
  getTaskTicketsText,
} from '../utils/rewardLabels';
import { usePointTasksContext } from './pointTasksContext';

export const useReferralReward = () => {
  const { getTasksByCode, loading } = usePointTasksContext();

  return useMemo(() => {
    const task = getTasksByCode(['referralReward'])[0];
    const ticketsText = getTaskTicketsText(task);
    const pointsText = getTaskPointsText(task);
    const thresholdText = getTaskThresholdText(task);
    const summaryText = [ticketsText, pointsText]
      .filter((text): text is string => Boolean(text))
      .join(' and ');

    return { task, ticketsText, pointsText, thresholdText, summaryText, loading };
  }, [getTasksByCode, loading]);
};
